import { useEffect, useState } from "react";
import { probeLinkSession } from "../services/api";
import { useSessionStore } from "../store/useSessionStore";

/**
 * Fills `userStatus.cipStatus` from GET session when claim did not include it
 * (older backends). Fail-open: if the probe errors, the splash may continue.
 */
export function useEnsureCipStatus(linkId?: string): boolean {
  const cipStatus = useSessionStore((s) => s.session.data?.userStatus?.cipStatus);
  const updateSession = useSessionStore((s) => s.updateSession);
  const [settled, setSettled] = useState(() => cipStatus !== undefined);

  useEffect(() => {
    if (!linkId) return;
    if (cipStatus !== undefined) {
      setSettled(true);
      return;
    }

    let cancelled = false;
    probeLinkSession(linkId)
      .then((result) => {
        if (cancelled) return;
        const current = useSessionStore.getState().session.data;
        if (!current) return;
        updateSession({
          ...current,
          userStatus: {
            blocked: result.blocked || current.userStatus?.blocked || false,
            suspended: current.userStatus?.suspended || false,
            cipStatus: result.cipStatus,
          },
        });
      })
      .catch(() => {
        // Fail-open: splash routing proceeds without a CIP gate.
      })
      .finally(() => {
        if (!cancelled) setSettled(true);
      });

    return () => {
      cancelled = true;
    };
  }, [linkId, cipStatus, updateSession]);

  return settled || cipStatus !== undefined;
}
